/**
 *  Convert value to a number, or return null if it is undefined
 *
 *  @param value    Value to convert to a number, returns null if this value
                    is null or undefined.
 */
export function cleanNullOrNumber(value) {
    return value !== null && typeof value !== 'undefined' ? Number(value) : null;
}
